import React from "react";

const DroppableColumn = ({ id, title, color, children }) => {
  return (
    <div className="column">
      <div className="column__header" style={{ background: color }}>
        <h2 className="column__title">{title}</h2>
      </div>
      <div className="orders-container">{children}</div>
    </div>
  );
};

export default DroppableColumn;
